/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useState, KeyboardEvent, useEffect, useContext } from 'react'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthLogin } from '../../services/Auth/Auth'
import { AuthContext } from '../../contexts/AuthContext/AuthContext'
import { resetSenha } from '../../services/AlteraSenha/postAlteraSenha'

export const useLogin = () => {
  const url = useLocation()
  const { authentified } = useContext(AuthContext)
  const XTENANTID = localStorage.getItem('X-TENANT-ID')

  const navigate = useNavigate()
  const goToPage = (page: string) => {
    navigate(page)
  }

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const [isEqueciSenha, setIsEsqueciSenha] = useState(true)
  const [emailEnviado, setEmailEnviado] = useState(true)

  const doLogin = async () => {
    // Guarda client-side: sem isto, e-mail/senha vazios geram um 400 de validacao
    // (@NotBlank) cuja mensagem tecnica ("must not be blank...") vazaria no toast.
    if (!email.trim() || !password) {
      toast.error('Informe e-mail e senha.')
      return
    }
    setIsLoading(true)
    const postLogin = await AuthLogin(email, password)
    setIsLoading(false)
    if (postLogin.logged) {
      window.location.href = '/dashboard1'

      return
    }
    toast.error(postLogin.message)
  }

  const resetarSenha = async () => {
    const resetSenhaRequestDTO = {
      email,
    }
    setIsLoading(true)
    const resetaSenha = await resetSenha(resetSenhaRequestDTO)
    setIsLoading(false)
    if ('info' in resetaSenha) {
      toast.success(resetaSenha.info)
      const timer = setTimeout(() => {
        goToPage('/')
      }, 4500)
      return () => clearTimeout(timer)
    }
    toast.error(resetaSenha.message)
  }

  const handleBackToLogin = () => {
    setIsEsqueciSenha(!isEqueciSenha)
    emailEnviado ? '' : setEmailEnviado(!emailEnviado)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      doLogin()
    }
  }

  const handleEmailEnviado = () => {
    setEmailEnviado(!emailEnviado)

    resetarSenha()
  }

  useEffect(() => {
    if (XTENANTID && authentified && url.pathname === '/') {
      goToPage('/dashboard')
    }
  }, [])

  return {
    email,
    setEmail,
    password,
    setPassword,
    isLoading,
    doLogin,
    handleKeyDown,
    isEqueciSenha,
    setIsEsqueciSenha,
    emailEnviado,
    setEmailEnviado,
    handleBackToLogin,
    handleEmailEnviado,
    resetarSenha,
  }
}
